export default __webpack_public_path__ + "static/media/tmp_file_image.7555c0f5.png";